import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormDiamond: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconFormDiamond"><Path d="M22.8086 12L11.998 22.8105L1.1875 12L11.998 1.18945L22.8086 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormDiamond;
